const acronyms = new Set(
  "ALL HR HRIS SSS BIR TIN DOLE PCAB HDMF EC EWT VAT CSV PDF JSON IP MFA RDO ZIP OT NC II III IV VI VII FY YTD CEO COO CFO IT SMAW IBIG PIN MID PEN ID".split(
    " ",
  ),
);

export function titleCase(value) {
  // Keep addresses, links and letter-number record references unchanged.
  return String(value).replace(
    /https?:\/\/\S+|[\w.+-]+@[\w.-]+|[\p{L}\p{N}]+(?:[-'][\p{L}\p{N}]+)*/gu,
    (word) => {
      if (word.includes("@") || word.includes("://") || /\d/u.test(word))
        return word;
      return word
        .split("-")
        .map((part) => {
          if (acronyms.has(part.toUpperCase()) || /^[A-Z]{2,3}$/.test(part))
            return part.toUpperCase();
          // Preserve intentional brand/name casing such as PhilHealth and McDonald.
          if (/\p{Ll}.*\p{Lu}/u.test(part))
            return part[0].toUpperCase() + part.slice(1);
          return part[0].toUpperCase() + part.slice(1).toLowerCase();
        })
        .join("-");
    },
  );
}

function isTextEntry(field) {
  if (!field.matches?.('input:not([type]), input[type="text"], textarea'))
    return false;
  if (field.disabled || field.readOnly || field.dataset.case === "preserve")
    return false;
  if (/^(decimal|numeric|email|url|tel)$/.test(field.inputMode)) return false;
  const key = `${field.id} ${field.name}`;
  return !/(?:code|password|email|username|token|secret|tin|sss|philhealth|pagibig|hdmf|rdo|registration|sec-ip|rg-no)/i.test(
    key,
  );
}

export function installCapitalization(root = document) {
  const selector =
    'h1,h2,h3,h4,h5,h6,button,label,summary,th,option,.lbl,.home-task-kind,nav a,[role="tab"]';
  function format() {
    root.querySelectorAll(selector).forEach((element) => {
      const walker = document.createTreeWalker(element, 4);
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (
          node.parentElement.closest(
            "textarea,script,style,[data-case='preserve']",
          )
        )
          continue;
        const next = titleCase(node.data);
        if (next !== node.data) node.data = next;
      }
    });
    root.querySelectorAll("input,textarea").forEach((field) => {
      if (
        field.placeholder &&
        field.type !== "email" &&
        field.type !== "password"
      ) {
        field.placeholder = titleCase(field.placeholder);
      }
      if (isTextEntry(field) && field !== document.activeElement)
        field.value = titleCase(field.value);
    });
  }
  function capitalize(event) {
    const field = event.target;
    if (!isTextEntry(field) || event.isComposing) return;
    const start = field.selectionStart,
      end = field.selectionEnd;
    const next = titleCase(field.value);
    if (next === field.value) return;
    field.value = next;
    if (start !== null) field.setSelectionRange(start, end);
  }
  // Capture before feature handlers read values into drafts or submit records.
  root.addEventListener("input", capitalize, true);
  root.addEventListener("change", capitalize, true);
  root.addEventListener("compositionend", capitalize, true);
  root.addEventListener(
    "submit",
    (event) => {
      event.target
        .querySelectorAll("input,textarea")
        .forEach((target) => capitalize({ target }));
    },
    true,
  );
  const observer = new MutationObserver(format);
  observer.observe(root, { childList: true, subtree: true });
  format();
  return observer;
}
